import styled from 'styled-components';
import { measures } from '../../theme/measures';

export const VirtualListOuterContainer = styled.div<{ isAssetManagement?: boolean }>`
  position: relative;
  width: 100%;
  height: calc(100vh - ${measures.headerHeight});
  overflow-y: auto;
  contain: strict;

  ${({ isAssetManagement }) =>
    isAssetManagement &&
    `
        margin-left: 6px;
        max-width: 1128px;
        padding: 6px 16px 16px 8px; /* just enough to contain the drop shadow */


    `}
`;

export const VirtualListInnerContainer = styled.div<{ isAssetManagement?: boolean }>`
  width: 100%;
  position: relative;

  ${({ isAssetManagement }) =>
    isAssetManagement &&
    `
      border-radius: 10px;
      box-shadow: 0 4px 13px 0 rgba(0, 0, 0, 0.25);
    `}
`;

export const VirtalListMoving = styled.div<{ isAssetManagement?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`;
